import {
  IMAGE_UPLOAD_START, IMAGE_UPLOAD, IMAGE_UPLOAD_SUCCESS, IMAGE_UPLOAD_FAILURE
} from './mutation-types'

export default {
  state: {
    images: {
      total: 0,
      current: 0,
      errors: [],
      status: null
    },
    imageUrl: null
  },
  getters: {
    imageUploadTotal: state => {
      return state.images.total
    },
    imageUploadCurrent: state => {
      return state.images.current
    },
    imageUploadErrors: state => {
      return state.images.errors
    },
    imageUploadStatus: state => {
      return state.images.status
    },
    imageUrl: state => {
      return state.imageUrl
    }
  },
  actions: {
    [IMAGE_UPLOAD_START] ({state}) {
      state.images.status = null
      state.images.errors = []
      state.images.current = 0
      state.images.total = 0
    },
    [IMAGE_UPLOAD] ({dispatch, state, commit}, params = null) {
      state.images.total ++
      dispatch('apiPatch', {url: '/images/upload/', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(IMAGE_UPLOAD_FAILURE, res.data)
            } else {
              commit(IMAGE_UPLOAD_SUCCESS, {data: res.data, callback: params.callback})
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [IMAGE_UPLOAD_FAILURE] (state, data) {
      console.log('IMAGE_UPLOAD_FAILURE')
      state.images.status = false
      state.images.errors.push(data.error)
    },
    [IMAGE_UPLOAD_SUCCESS] (state, data) {
      console.log('IMAGE_UPLOAD_SUCCESS')
      state.images.current ++
      if (state.images.current === state.images.total) {
        state.images.status = true
      }
      if (data.callback !== null) {
        data.callback(data.data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/image.js